export default __webpack_public_path__ + "static/media/98.93d9c5a5.jpg";